import {User} from '@app/core/models/user.model';
import {Shift} from '@app/core/models/shift.model';
import {FileEntry} from '@app/core/models/fileEntry.model';
import {RDate} from '@app/core/models/rDate.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';

export class Message extends BaseModel {
	public id: number;
	public content: string;
	public user: User;
	public file_entries: FileEntry[];
	public shift: Shift;
	public shift_stock: number;
	public type: number;
	public created_at: RDate;
	public updated_at: RDate;

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public deserialize(input: any): this {
		Object.assign(this, input);

		if (input === undefined) {
			return;
		}

		if (input.shift && !(input.shift instanceof Shift)) {
			this.shift = new Shift(this.tenantTZ, this.interService).deserialize(input.shift);
		}
		if (input.user && !(input.user instanceof User)) {
			this.user = new User(this.tenantTZ, this.interService).deserialize(input.user);
		}
		if (input.created_at && !(input.created_at instanceof RDate)) {
			this.created_at = new RDate(this.tenantTZ, this.interService).deserialize(input.created_at);
		}
		if (input.updated_at && !(input.updated_at instanceof RDate)) {
			this.updated_at = new RDate(this.tenantTZ, this.interService).deserialize(input.updated_at);
		}

		return this;
	}
}
